import {
  BaseDialogLayout,
  CustomIcons,
  StyledInputTextField
} from 'modules';
import { appFormUtil } from 'modules/common';
import { useState } from 'react';



export type RegisterConfirmationModalProps<T extends object> = {
  isVisible: boolean;
  handleClose: () => void;
  handleConfirmCode: (code: string) => void;
  form: appFormUtil.InferReturn<T>;
};

export const FC = <T extends object,> (props: RegisterConfirmationModalProps<T>) => {
  const [
    code,
    setCode
  ] = useState('');

  const textFieldProps = props.form.genFieldProps('code' as keyof T);

  return (
    <BaseDialogLayout.FC
      formTitle='Confirmation Code'
      handleClose={() => props.handleClose()}
      handleSubmit={() => {
        props.handleConfirmCode(code);
        console.log('Code sent');
      }}
      isVisible={props.isVisible}
      saveText='Confirm'
      subTitle='Check your email for a confirmation code.'
      titleIcon={<CustomIcons.LargeIcon.FC icon='MAGNIFYINGGLASS' />}
    >
      <StyledInputTextField.FC
        key='code'
        value={code}
        onChange={(e) => setCode(() => e.target.value)}
      />

    </BaseDialogLayout.FC>
  );
};
